import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMFormatterService } from '@list/formatters';

export const lmAlphaSerializer = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  value: string,
  oldValue: string,
  columnDef: ListGridColumn,
  row: number,
  cell: number,
  dataView: LMListDataView
): string => {
  // Datagrid is escaping html special characters with encoded symbols. For example,
  // the backslash character of '\u00AD' is replaced with the character entity of '&bsol;'.
  value = value ? value.replace('&bsol;u00AD', '\u00AD') : value;

  // Use common service to handle special and non-printable characters
  return lmFormatUtilService.toDataValue(value, columnDef.displayField.type);
};
